import * as React from 'react'
import type { SVGProps } from 'react'
const LandingBuildingOffice = (props: SVGProps<SVGSVGElement>) => (
<svg {...props} xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
  <path opacity="0.2" d="M4.83398 3.75V20.25H8.58398V15H13.084V20.25H16.834V3.75H4.83398Z" fill="#002A73"/>
  <path d="M2.58398 20.25H23.584" stroke="#002A73" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M7.83398 7.5H9.33398" stroke="#002A73" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.334 7.5H13.834" stroke="#002A73" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M7.83398 11.25H9.33398" stroke="#002A73" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.334 11.25H13.834" stroke="#002A73" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.58398 20.25V15H13.084V20.25" stroke="#002A73" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M4.83398 3.75V20.25" stroke="#002A73" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M16.834 20.25V3.75" stroke="#002A73" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M4.08398 3.75H17.584" stroke="#002A73" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M21.334 20.25V8.25" stroke="#002A73" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M16.834 8.25H22.084" stroke="#002A73" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

)
export default LandingBuildingOffice